
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import PagedDataTable from '@/components/PagedDataTable.vue';
import WeeklySignRepository from '@/repositories/WeeklySign/WeeklySignRepository';

@Component({
    components: { GeneralScaffold, PagedDataTable },
})
export default class WeeklySignListScreen extends Vue {
    @Inject()
    private readonly weeklySignRepository!: WeeklySignRepository;

    public get headers(): any[] {
        return [
            {
                text: this.$t('general.actions'),
                value: 'action',
                sortable: false,
            },
            {
                text: this.$t('crud.weeklySign.defaultTitle'),
                align: 'left',
                value: 'defaultName',
                sortable: true,
            },
            {
                text: this.$t('crud.weeklySign.weekOf'),
                value: 'weekOf',
                sortable: true,
            },
        ];
    }
}
